import { Box, Menu, MenuItem, styled } from '@mui/material';

export const CreateActionMenuContainer = styled(Menu, {
  shouldForwardProp: (prop: string) => !['isMobile', 'isMobileVariant'].includes(prop),
})<{ isMobile: boolean; isMobileVariant?: boolean }>(({ theme, isMobile, isMobileVariant }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: isMobile ? theme.palette.case.neutral.n800 : 'transparent',
    opacity: '0.6000000238418579 !important',
  },
  '& .MuiMenu-paper': {
    marginTop: theme.spacing(1),
    boxShadow: isMobileVariant ? 'none' : '0px 2px 8px 0px rgba(38, 44, 74, 0.08)',
    borderRadius: isMobile ? '8px 8px 0 0 ' : '8px',
    border: isMobileVariant ? '' : `1px solid ${theme.palette.case.neutral.n200}`,
    backgroundColor: theme.palette.case.background,
    width: '200px',

    [theme.breakpoints.down('sm')]: isMobileVariant
      ? {
          width: '100%',
          maxWidth: '100%',
          top: 'auto !important',
          bottom: '0',
          left: '0px !important',
          right: '0px !important',
        }
      : {},
  },
  '& .MuiMenu-list': {
    padding: '0',
  },
}));

export const CreateActionMenuHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: '16px',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.case.neutral.n200}`,
}));

export const CreateActionMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop: string) => !['isMobile', 'isMobileVariant', 'isBorderBottom'].includes(prop),
})<{ isMobile: boolean; isMobileVariant?: boolean; isBorderBottom?: boolean }>(
  ({ theme, isMobile, isMobileVariant, isBorderBottom }) => ({
    boxShadow: 'none',
    borderRadius: isMobile ? '8px' : isBorderBottom ? '4px 4px 0 0' : '4px',
    border: isMobile ? `1px solid ${theme.palette.case.neutral.n200}` : 'none',
    borderBottom: isBorderBottom || isMobile ? `1px solid ${theme.palette.case.neutral.n200}` : 'none',
    height: '36px',
    padding: isMobile ? '12px' : '8px',
    backgroundColor: isMobile ? theme.palette.case.background : 'transparent ',
    width: '100%',
    marginBottom: '2px',
    svg: {
      width: isMobileVariant ? '24px' : '20px',
      height: isMobileVariant ? '24px' : '20px',
      path: {
        fill: isMobileVariant ? theme.palette.case.neutral.n600 : theme.palette.case.neutral.n500,
      },
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
      minHeight: isMobileVariant ? '48px' : ' 36px',
    },
    '&:hover': {
      backgroundColor: theme.palette.case.neutral.n100,
      color: theme.palette.case.contrast.black,
    },
    '&.Mui-disabled': {
      backgroundColor: theme.palette.case.background,
      color: theme.palette.case.neutral.n400,
      cursor: 'not-allowed !important',
    },
  }),
);
